import request from '@/API/';
import events from '@/API/services/events';

export default {
  state: {
    clients: [],
    currentClient: null,
    globalEvents: null,
    eventsData: null,
    eventsDataCount: null,
    eventLogSelectedEvent: null,
    eventsLogFilterOptions: {},
  },
  mutations: {
    SET_EVENT_LOG_SELECTED_EVENT: (state, payload) => {
      state.eventLogSelectedEvent = payload;
    },
    SET_CLIENTS: (state, payload) => {
      state.clients = payload;
      state.currentClient = payload[0];
    },
    SET_GLOBAL_EVENTS: (state, payload) => {
      state.globalEvents = payload;
    },
    SET_EVENTS_DATA: (state, payload) => {
      state.eventsData = payload.data;
      state.eventsDataCount = payload.count;
      state.offset = payload.options.o;
      state.limit = payload.options.l;
      state.query = payload.options.q;
    },
    SET_EVENT_LOG_FILTER_OPTIONS: (state, payload) => {
      state.eventsLogFilterOptions = payload;
    },
  },
  actions: {
    setEventsLogFilterOptions: ({ commit }, payload) => {
      commit('SET_EVENT_LOG_FILTER_OPTIONS', payload)
    },
    setEventLogSelectedEvent: ({ commit }, payload) => {
      commit('SET_EVENT_LOG_SELECTED_EVENT', payload)
    },
    getClients: async ({ commit }) => {
      try {
        const response = await request.get('user/clientlist?s=events');
        commit('SET_CLIENTS', response.data);
      } catch(err) {
        console.log(err);
      }
    },
    fetchGlobalEventsDashboard: async ({ commit }, payload) => {
      try {
        const { data } = await events.getGlobalEvents(payload);
        commit('SET_GLOBAL_EVENTS', data);
      } catch(err) {
        console.log(err);
      }
    },
    fetchEventsData: async ({ commit }, payload) => {
      try {
          const { data } = await events.getEventsData(payload);
          data.options = payload;
          if(data.data === null) { data.data = []; }
          commit('SET_EVENTS_DATA', data);
      } catch(err) {
        console.log(err);
      }
    },
    prependEventToEventsData: async ({ state }, payload) => {
      try {
        if(state.eventsData[0].ref !== payload.event_id) {
          state.eventsData.unshift(payload);
          state.eventsDataCount++;
          state.eventsData.splice(-1,1)
        }
      } catch(err) {
        console.log(err);
      }
    }
  },
}
